import { useState } from 'react';
import axios from 'axios';

const useAddVendor = () => {
  const [loadingAddVendor, setLoadingAddVendor] = useState(false);
  const [errorAddVendor, setErrorAddVendor] = useState(null);

  const addVendor = async (vendorName) => {
    setLoadingAddVendor(true);
    setErrorAddVendor(null);

    if (!vendorName) {
      setErrorAddVendor('Vendor Name is required.');
      setLoadingAddVendor(false);
      return { success: false, message: 'Vendor Name is required.' };
    }

    try {
      const payload = {
        companyName: vendorName,
        complianceStatus: 'Not NetSuite Approved',
      };

      const response = await axios.post(`/api/Vendor/add-vendor`, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        return { success: true, message: 'Vendor has been added successfully.' };
      } else {
        return { success: false, message: 'Error adding vendor.' };
      }
    } catch (error) {
      setErrorAddVendor(error.message || 'Error adding vendor.');
      console.error('Error adding vendor:', error);
      return { success: false, message: error.message };
    } finally {
      setLoadingAddVendor(false);
    }
  };

  return { addVendor, loadingAddVendor, errorAddVendor };
};

export default useAddVendor;
